export const config = {
  title: "TCI Flooring | Trusted Flooring Services in Guelph, Ontario",
  meta: {
    description:
      "TCI Flooring offers professional flooring services in Guelph, Ontario, providing high-quality installations and a wide range of flooring options to enhance your space.",
    keywords: [
      'Flooring Services Guelph',
      'TCI Flooring',
      'Floor Installation',
      'Hardwood Flooring',
      'Laminate Flooring',
      'Vinyl Flooring',
      'Tile Flooring',
      'Residential Flooring',
      'Commercial Flooring',
      'Guelph Ontario Flooring',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "TCI Flooring",
    canonicalUrl: 'https://www.tciflooring.com/index.php',
  },
  sections: {
    header: {
      businessName: "TCI Flooring",
    },
    sectionB: {
      heroTitle: "TCI Flooring",
      heroSubtitle: 'Your Trusted Flooring Service Provider in Guelph',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '+15198411145',
      phoneLabel: '(519) 841-1145',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1386919813/photo/worker-installing-laminated-wooden-floor-indoors-closeup.jpg?s=612x612&w=0&k=20&c=mRc-079FbZ2e23jop7qqNofmEoXRfO7CBI1nPp0rxK4=',
      cardData: [
        {
          title: 'Mission',
          description:
            'At TCI Flooring, our mission is to deliver top-quality flooring solutions that combine durability, aesthetics, and affordability, ensuring customer satisfaction with every project.',
        },
        {
          title: 'Vision',
          description:
            'To be the leading flooring service provider in Guelph, recognized for our commitment to excellence, innovative solutions, and exceptional customer service.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With a team of experienced professionals, we offer a wide range of flooring options and personalized services tailored to meet the unique needs of our clients.',
        },
      ],
      description:
        "TCI Flooring specializes in the installation of various flooring types, including hardwood, laminate, vinyl, and tile. Our team is dedicated to transforming your space with high-quality materials and expert craftsmanship.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover our comprehensive flooring services designed to enhance the beauty and functionality of your home or business.",
      cards: [
        {
          title: 'Hardwood Flooring Installation',
          description:
            "Enhance the elegance of your space with our professional hardwood flooring installation services, offering a timeless and durable flooring solution.",
          imageSrc:
            'https://www.tciflooring.com/uploads/job6.jpg',
          imageAlt: 'Hardwood Flooring Installation'
        },
        {
          title: 'Laminate Flooring Installation',
          description:
            "Achieve the look of natural wood or stone with our cost-effective laminate flooring options, installed by our skilled team for a flawless finish.",
          imageSrc:
            'https://www.tciflooring.com/uploads/job8.jpg',
          imageAlt: 'Laminate Flooring Installation',
        },
        {
          title: 'Vinyl Flooring Installation',
          description:
            'Opt for versatility and resilience with our vinyl flooring solutions, ideal for both residential and commercial spaces.',
          imageSrc:
            'https://www.tciflooring.com/uploads/job1_1.jpg',
          imageAlt: 'Vinyl Flooring Installation',
        },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://www.tciflooring.com/uploads/job5.jpg',
        alt: "TCI Flooring Team",
      },
      aboutText: [
        "At TCI Flooring, we are passionate about providing exceptional flooring services to the Guelph community. Our team of experts is committed to delivering quality workmanship and personalized solutions to meet your specific flooring needs.",
        "With years of experience in the industry, we pride ourselves on our attention to detail, use of premium materials, and dedication to customer satisfaction. Whether you're renovating your home or upgrading your business space, TCI Flooring is here to bring your vision to life.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "TCI Flooring",
      businessName: "TCI Flooring",
      contact: {
        phone: '+15198411145',
        phoneLabel: '(519) 841-1145',
        email: 'tciflooringg@gmail.com',
        website: 'https://www.tciflooring.com/',
        address: 'Guelph, Ontario',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Guelph, Ontario',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.5170000000003!2d-80.25000000000001!3d43.550000000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b9a0f00000000%3A0x0000000000000000!2sGuelph%2C%20ON!5e0!3m2!1sen!2sca!4v1700000000000!5m2!1sen!2sca',
    },
  },
};

export default config;
